import styled from 'styled-components';
export const CheckboxStyled = styled.label `
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;

  ${({ alignTop }) => alignTop &&
    `
    align-items: flex-start;
  `};

  ${({ disabled }) => disabled &&
    `
    opacity: 0.3;
    pointer-events: none;
    cursor: default;
  `};

  ${({ variant, theme, error }) => variant === 'tappable' &&
    `
    border: ${error ? '2px' : '1px'} solid ${error ? theme.ColorStatusAttention500 : theme.ColorGrey400};
    border-radius: 8px;
    padding: 16px;
  `};

  ${({ error }) => error && `margin-bottom: 6px;`}
`;
export const InputCheckboxStyled = styled.input `
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  height: 100%;
  width: 100%;
  opacity: 0;
`;
export const TickWrapStyled = styled.span `
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  min-width: 24px;
  margin: 0 12px 0 0;
  border: ${({ checked, theme }) => checked ? `1px solid transparent` : `1px solid ${theme.ColorGrey400}`};
  border: ${({ error, theme }) => error && `2px solid ${theme.ColorStatusAttention500}`};
  border-radius: 4px;
  background: ${({ checked, theme, error }) => error
    ? theme.ColorStatusAttention25
    : checked
        ? theme.ColorButtonSolidSecondaryBackground
        : 'white'};
  transition: background 100ms ease, border 100ms ease;

  &:hover {
    border: ${({ checked, theme }) => checked ? `1px solid transparent` : `1px solid ${theme.ColorGrey800}`};
  }

  &:focus-within {
    box-shadow: 0 0 0 4px ${({ theme }) => theme.ColorGrey100};
  }
  svg {
    fill: ${({ error, theme }) => error ? 'transparent' : theme.ColorButtonSolidSecondaryText};
  }
`;
export const LabelStyled = styled.span `
  padding-top: 1px;
`;
export const HintStyled = styled.span `
  padding-top: 1px;
  margin-left: auto;
`;
//# sourceMappingURL=checkbox.styles.js.map